import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import ptBr from '@angular/common/locales/pt';

import { CommonModule, registerLocaleData } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DependenteComponent } from './components/dependente/dependente.component';
import { HomeComponent } from './components/home/home.component';
import { DialogComponent } from './shared/components/dialog/dialog.component';
import { StepperComponent } from './shared/components/stepper/stepper.component';

import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { CdkAccordionModule } from '@angular/cdk/accordion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSortModule } from '@angular/material/sort';

import { A11yModule } from "@angular/cdk/a11y";
import { ClipboardModule } from '@angular/cdk/clipboard';
import { HttpClientModule } from '@angular/common/http';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { EnderecoEntregaComponent } from './components/endereco-entrega/endereco-entrega.component';
import { FinalizacaoComponent } from './components/finalizacao/finalizacao.component';
import { FormaEntregaComponent } from './components/forma-entrega/forma-entrega.component';
import { FormaPagamentoComponent } from './components/forma-pagamento/forma-pagamento.component';
import { ListaMaterialComponent } from './components/lista-material/lista-material.component';
import { MinhasComprasComponent } from './components/minhas-compras/minhas-compras.component';
import { PoliticaPrivacidadeComponent } from './components/politica-privacidade/politica-privacidade.component';
import { PoliticaVendasComponent } from './components/politica-vendas/politica-vendas.component';
import { ExibeMenuService } from './service/shared/exibe-menu.service';
import { DialogAcessaCompraComponent } from './shared/components/dialog-acessa-compra/dialog-acessa-compra.component';
import { DialogItinerarioComponent } from './shared/components/dialog-itinerario/dialog-itinerario.component';
import { DialogListaComponent } from './shared/components/dialog-lista/dialog-lista.component';
import { DialogLoadingComponent } from './shared/components/dialog-loading/dialog-loading.component';
import { ValidadorCpfDirective } from './shared/validador-cpf.directive';
import { InfoErroComponent } from './components/info-erro/info-erro.component';

registerLocaleData(ptBr);

const COMMONS = [
  MatToolbarModule,
  MatButtonModule,
  MatChipsModule,
  MatIconModule,
  MatListModule,
  MatInputModule,
  MatDialogModule,
  MatSnackBarModule,
  MatStepperModule,
  MatTooltipModule,
  MatFormFieldModule,
  MatSelectModule,
  MatTableModule,
  MatPaginatorModule,
  MatSortModule,
  MatProgressBarModule,
  MatCheckboxModule,
  MatCardModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatDividerModule,
  MatExpansionModule,
  CdkAccordionModule,
  MatMenuModule,
  ClipboardModule
]

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    StepperComponent,
    DependenteComponent,
    DialogComponent,
    ListaMaterialComponent,
    EnderecoEntregaComponent,
    FormaEntregaComponent,
    FormaPagamentoComponent,
    FinalizacaoComponent,
    PoliticaVendasComponent,
    DialogLoadingComponent,
    PoliticaPrivacidadeComponent,
    ValidadorCpfDirective,
    DialogListaComponent,
    DialogItinerarioComponent,
    DialogAcessaCompraComponent,
    MinhasComprasComponent,
    InfoErroComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    FontAwesomeModule,
    COMMONS,
    A11yModule,
],
  providers: [provideNgxMask(), { provide: LOCALE_ID, useValue: 'pt' }, ExibeMenuService],
  bootstrap: [AppComponent],
})
export class AppModule { }
